import type { EditorProps } from "../editor-props"
import { MessageBody } from "../message-body"
import { SendOptionsFields } from "../send-options-fields"

export function MessageEditor(props: EditorProps) {
	return (
		<div className="space-y-4">
			<MessageBody {...props} allowGallery />
			<SendOptionsFields config={props.config} onChange={props.onChange} />
		</div>
	)
}
